module.exports = __webpack_public_path__ + "static/face-e1415c7ae7a57a935e50b6ee0c9fb852.jpg";